import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name || u.email}`);
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-20">
      <p className="small-label">Account</p>
      <h1 className="font-serif text-4xl mt-3">Welcome back</h1>
      <form onSubmit={submit} className="mt-8 space-y-3">
        <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <button disabled={busy} data-testid="login-submit" className="btn-primary w-full">{busy ? "Logging in…" : "Login"}</button>
      </form>
      <p className="text-sm text-stone mt-6 text-center">No account yet? <Link to="/register" className="underline text-charcoal">Create one</Link></p>
    </div>
  );
}
